export enum CursorParams {
  name = 'cursor_name',
  id = 'cursor_id',
  value = 'cursor_value',
}
